const init = () => {
    const ourCampaignsBlocks = document.querySelectorAll('.our-campaigns')
    if (!ourCampaignsBlocks.length) {
        return
    }

    ourCampaignsBlocks.forEach(currentBlock => {
        const currentCampaign = currentBlock.querySelectorAll('.our-campaigns__campaign')
        const currentNavLinks = currentBlock.querySelectorAll('.our-campaigns__nav-list-item')
        showInitialStep(currentCampaign)
        setInitialActiveNavLink(currentNavLinks)
        handelNavLinks(currentNavLinks, currentBlock)
        bgLineSlideInOnScroll(currentBlock)
    })

    function showInitialStep(steps) {
        steps[0].classList.remove('hidden')
    }

    function setInitialActiveNavLink(navLinks) {
        if (navLinks.length) {
            navLinks[0].classList.add('active')
        }
    }

    function handelNavLinks(navLinks, block) {
        navLinks.forEach(navLink => {
            navLink.addEventListener('click', () => {
                highlightCurrentNavLink(navLinks, navLink)
                showCurrentCampaign(navLink, block)
            })
        })
    }

    function highlightCurrentNavLink(navLinks, currentLink) {
        navLinks.forEach(navLink => {
            navLink.classList.remove('active')
        })
        currentLink.classList.add('active')
        scrollToEl(currentLink)
    }

    function showCurrentCampaign(link, block) {
        const campaigns = block.querySelectorAll('.our-campaigns__campaign')
        const linkId = link.id.split('-')[1]

        campaigns.forEach(campaign => {
            let isCurrentCampaign = linkId === campaign.id.split('-')[1]
            let children = [...campaign.children]
            if (isCurrentCampaign) {
                setTimeout(() => {
                    children.forEach(c => {
                        if (!c.classList.contains('our-campaigns__campaign--bg-image')) {
                            c.classList.remove('our-campaigns__campaign--fade-out')
                            c.classList.add('our-campaigns__campaign--fade-in')
                            campaign.classList.remove('hidden')
                        }
                    })
                }, 75)
            }
            if (!isCurrentCampaign) {
                setTimeout(() => {
                    children.forEach(c => {
                        if (!c.classList.contains('our-campaigns__campaign--bg-image')) {
                            c.classList.add('our-campaigns__campaign--fade-out')
                            c.classList.remove('our-campaigns__campaign--fade-in')
                            campaign.classList.add('hidden')

                        }
                    })
                }, 75)
            }
        })
    }

    function scrollToEl(el) {
        const elLeft = el.offsetLeft + el.offsetWidth + 50;
        const elParentLeft = el.parentNode.offsetLeft + el.parentNode.offsetWidth;

        // check if element not in view
        if (elLeft >= elParentLeft + el.parentNode.scrollLeft) {
            let goal = elLeft - elParentLeft
            for (let i = 0; i <= goal; i++) {
                setTimeout(() => {
                    el.parentNode.scrollLeft = i
                }, 0)
            }
        } else {
            el.parentNode.scrollLeft = (el.offsetLeft - el.parentNode.offsetLeft) - 50;
        }
    }

    function bgLineSlideInOnScroll(block) {
        let lineContainer = block.querySelector('.our-campaigns__campaign-wrapper')
        let options = {
            root: document.window,
            rootMargin: '500px',
            threshold: 1.0
        }

        let callback = (entries) => {
            entries.forEach((entry) => {
                let isIntersecting = entry.isIntersecting
                let slider = document.createElement("div");
                slider.classList.add('our-campaigns__campaign--bg-image-slider')
                if (isIntersecting) {
                    lineContainer.insertAdjacentElement('afterbegin', slider)
                } else {
                    slider.remove()
                }
                if (entry.intersectionRatio > 0) {
                    observer.unobserve(block);
                }
            });
        };
        let observer = new IntersectionObserver(callback, options);
        observer.observe(block);
    }
}

document.addEventListener('DOMContentLoaded', init)
